export const LETTERS_ERROR = 'LETTERS_ERROR';
export const LETTERS_LOADING = 'LETTERS_LOADING';
export const LETTERS_GET_GRADES = 'LETTERS_GET_GRADES';
export const LETTERS_PROCESS_LETTERS = 'LETTERS_PROCESS_LETTERS';
export const LETTERS_GET_BAD_EMAILS = 'LETTERS_GET_BAD_EMAILS';
export const LETTERS_CLEAR_BAD_EMAILS_STUDENT =
  'LETTERS_CLEAR_BAD_EMAILS_STUDENT';
export const LETTERS_CLEAR_BAD_EMAILS_TEACHER =
  'LETTERS_CLEAR_BAD_EMAILS_TEACHER';
export const LETTERS_CLEAR_BAD_EMAILS_LOWBALANCE =
  'LETTERS_CLEAR_BAD_EMAILS_LOWBALANCE';
export const LETTERS_CLEAR_ERROR = 'LETTERS_CLEAR_ERROR';



// WEBPACK FOOTER //
// ./src/pages/letters/state/letters/types.js